import React from "react";
import { Link } from "react-router-dom";
import { Feather } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-[hsl(var(--border))] mt-24 bg-[hsl(var(--muted))]/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-8 h-8 rounded-full bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] flex items-center justify-center">
              <Feather size={16} />
            </span>
            <span className="font-display text-xl">Humanly</span>
          </div>
          <p className="text-sm text-[hsl(var(--muted-foreground))] max-w-sm">
            Rewrite AI-generated text into natural, human-sounding prose. For writers, marketers, students, and everyone in between.
          </p>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Product</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/pricing" className="link-underline">Pricing</Link></li>
            <li><Link to="/dashboard" className="link-underline">Dashboard</Link></li>
            <li><Link to="/history" className="link-underline">History</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="link-underline">Privacy</Link></li>
            <li><Link to="/terms" className="link-underline">Terms</Link></li>
          </ul>
        </div>
      </div>
      <div className="text-center text-xs text-[hsl(var(--muted-foreground))] pb-8">© {new Date().getFullYear()} Humanly. Crafted with warmth.</div>
    </footer>
  );
}
